import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../contexts/authContext';
import { deliveryClient } from '../../../lib/connect/clients';
const KEY = 'admin-notification-delivery-status';
/**
 * useNotificationDeliveryStatus fetches the tenant's most recent notifications
 * with each recipient's per-channel delivery state (ACC-12 admin surface).
 *
 * companyId is left empty on purpose — ryugu resolves the tenant from the
 * gateway principal and gates the RPC on the admin/internal role, the same
 * convention the rest of /admin uses. notificationEventId defaults to empty
 * (list mode, the tenant-wide newest-first window); passing one drills into
 * exactly that event (SAD-322 — otherwise a journey's own rows can be pushed
 * off the shared, capped window by other notification volume).
 *
 * The response is projected to the signed-in admin's program scope, so the
 * cache is keyed on the principal id: without it, a different admin signing in
 * within the same browser session could read statuses cached for the previous
 * one.
 */ export function useNotificationDeliveryStatus(notificationEventId = '', limit = 50) {
    const { user } = useAuth();
    return useQuery({
        queryKey: [
            KEY,
            user?.id ?? '',
            notificationEventId,
            limit
        ],
        queryFn: async ()=>{
            const resp = await deliveryClient.listNotificationDeliveryStatus({
                companyId: '',
                notificationEventId,
                limit
            });
            return resp.statuses;
        },
        enabled: !!user?.id,
        staleTime: 30000
    });
}
